var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightDoubleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.389285 8.8548L4.04963 5.19446C4.15725 5.08684 4.15725 4.91272 4.04963 4.80554L0.389286 1.1452C0.18236 0.938272 0.18236 0.60273 0.389286 0.395367L0.629459 0.155194C0.836384 -0.0517315 1.17193 -0.0517315 1.37929 0.155194L5.84152 4.61743C6.05282 4.82873 6.05282 5.17127 5.84152 5.38257L1.37929 9.84481C1.17236 10.0517 0.836821 10.0517 0.629458 9.84481L0.389285 9.60463C0.18236 9.39771 0.18236 9.06216 0.389285 8.8548Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.38929 8.8548L8.04963 5.19446C8.15725 5.08684 8.15725 4.91272 8.04963 4.80554L4.38929 1.1452C4.18236 0.938272 4.18236 0.60273 4.38929 0.395367L4.62946 0.155194C4.83638 -0.0517315 5.17193 -0.0517315 5.37929 0.155194L9.84152 4.61743C10.0528 4.82873 10.0528 5.17127 9.84152 5.38257L5.37929 9.84481C5.17236 10.0517 4.83682 10.0517 4.62946 9.84481L4.38929 9.60463C4.18236 9.39771 4.18236 9.06216 4.38929 8.8548Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightDoubleIcon);
export default __webpack_public_path__ + "static/media/ArrowRightDoubleIcon.02a0deec3a4b5d38ce1441c3f4568a5f.svg";
export { ForwardRef as ReactComponent };